import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type EstimatedTaxCardInChat = {
  entityId: string;
  quarter: number;
  year: number;
  label: string;
  status: string;
  deadline: string;
  estimated_payment: number | null;
  paid_amount: number;
  channel_url: string;
};

const estimatedTaxCardInChat = createSlice({
  name: "estimatedTaxCardInChat",
  initialState: null as EstimatedTaxCardInChat | null,
  reducers: {
    setEstimatedTaxCardInChat: (
      _,
      action: PayloadAction<EstimatedTaxCardInChat>
    ) => action.payload,
    clearEstimatedTaxCardInChat: () => null,
  },
});

export const { setEstimatedTaxCardInChat, clearEstimatedTaxCardInChat } =
  estimatedTaxCardInChat.actions;
export default estimatedTaxCardInChat.reducer;
